import { useFormik } from "formik";
import { useEffect } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  getCurrentUserData,
  notifyBugsnagError,
  showToast,
} from "../../../common/utils/Functions";
import useFetch from "../../../hooks/useFetch";
import { linkToGuestySchema } from "../../../validations/guestySchema";
import ModalLayout from "../../layouts/ModalLayout";
import InputField from "../../theme/InputField";
import ThemeButton from "../../theme/ThemeButton";

interface Iprops {
  handleClose: () => void;
  show: boolean;
  title?: string;
}

const LinkToGuestyModal = ({ handleClose, show, title }: Iprops) => {
  const { uuid } = useParams();
  const userData = getCurrentUserData(`${uuid}`);

  /** -----@linkToGuestyApi ------ */
  const [
    linkToGuestyApi,
    {
      response: linkToGuestyResponse,
      loading: linkToGuestyLoading,
      error: linkToGuestyError,
    },
  ] = useFetch(`/organization/guesty-integration`, {
    method: "post",
  });

  const formik = useFormik({
    initialValues: {
      token: "",
    },
    validationSchema: linkToGuestySchema,
    onSubmit: (values) => {
      try {
        linkToGuestyApi({
          org_id: userData?.organization_details?.id,
          token: values?.token?.trim(),
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "linkToGuestyApi" });
      }
    },
  });

  /** Handle @linkToGuestyApi response */
  useEffect(() => {
    if (linkToGuestyResponse) {
      showToast(linkToGuestyResponse.message as string, "success");
      formik.resetForm();
      handleClose();
    }
    if (linkToGuestyError) {
      showToast(linkToGuestyError.message as string, "error");
    }
  }, [linkToGuestyResponse, linkToGuestyError]);

  useEffect(() => {
    if (!show) {
      formik.resetForm();
    }
  }, [show]);

  return (
    <ModalLayout
      title={title}
      show={show}
      size={500}
      handleToggle={() => {
        formik.resetForm();
        handleClose();
      }}
    >
      <Row className="g-xl-4 g-3">
        <Col xxl={12} xl={12}>
          <InputField
            type="text"
            name="token"
            label="Input Guesty Partner Token"
            placeholder="Enter Guesty Partner Token"
            formik={formik}
            autoComplete="off"
          />
        </Col>
      </Row>
      <Modal.Footer>
        <ThemeButton
          loading={linkToGuestyLoading}
          onClick={() => formik.handleSubmit()}
          disabled={!formik.values.token || linkToGuestyLoading}
          className="guesty_btn"
        >
          Link to Guesty
        </ThemeButton>
      </Modal.Footer>
    </ModalLayout>
  );
};

export default LinkToGuestyModal;